import { render, staticRenderFns } from "./SidebarToggler.vue?vue&type=template&id=f0976066"
import script from "./SidebarToggler.vue?vue&type=script&lang=js"
export * from "./SidebarToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports